import { Empty, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Button } from '~/app/components/common/Button';
import { AssetLogJsonPayload } from '~/app/components/asset-detail/AssetLogJsonPayload';
import { copyAssetLogPayload } from '~/app/components/asset-detail/assetLogContent.utils';
import styles from '~/app/components/asset-detail/AssetLogsTable/AssetLogsTable.module.css';
import type { AssetOcppConfigurationSnapshot } from '../../types';

export interface AssetOcppConfigurationJsonPanelProps {
  snapshot: AssetOcppConfigurationSnapshot | null;
}

export function AssetOcppConfigurationJsonPanel({
  snapshot,
}: AssetOcppConfigurationJsonPanelProps) {
  const { t } = useTranslation('assets');

  if (!snapshot) {
    return (
      <Empty
        description={t(
          'detail.ocppConfiguration.jsonEmpty',
          'No snapshot JSON',
        )}
      />
    );
  }

  const handleCopy = async () => {
    const ok = await copyAssetLogPayload(snapshot);
    if (ok) {
      message.success(
        t('detail.ocppConfiguration.copySuccess', 'Configuration JSON copied'),
      );
      return;
    }
    message.error(
      t(
        'detail.ocppConfiguration.copyError',
        'Failed to copy configuration JSON',
      ),
    );
  };

  return (
    <section className={styles.payloadCard}>
      <div className={styles.payloadHeader}>
        <h4 className={styles.payloadTitle}>
          {t('detail.ocppConfiguration.jsonTitle', 'Configuration (JSON)')}
        </h4>
        <Button
          type="default"
          size="small"
          icon={<CopyOutlined />}
          className={styles.payloadCopyButton}
          onClick={() => {
            void handleCopy();
          }}
        >
          {t('detail.logs.copy', 'Copy')}
        </Button>
      </div>
      <div className={styles.payloadBody}>
        <AssetLogJsonPayload value={snapshot} maxHeight={480} />
      </div>
    </section>
  );
}
